import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea"]

  connect() {
    this.originalContent = this.element.querySelector('[data-original-content]')?.dataset.originalContent
    this.messageId = this.element.closest('[id^="message_"]')?.id.split('_')[1]
  }

  cancel() {
    if (this.originalContent && this.messageId) {
      // Restore original content using Turbo Stream
      const messageContentElement = document.getElementById(`message_content_${this.messageId}`)
      if (messageContentElement) {
        messageContentElement.innerHTML = this.originalContent
      }
    }
  }
}
